import { api } from '../client';
import { unwrap } from '../unwrap';
import type { TaskFrame, TaskStatusResponse } from '@/core/models/processingTask';

export interface CreateTaskPayload {
  input_type: 'audio' | 'text';
  recording_id?: string;
  text?: string;
  note_id?: string;
  idempotency_key?: string;
  image_urls?: string[];
  client_metrics?: Record<string, unknown>;
}

export const processingTasksApi = {
  async create(payload: CreateTaskPayload): Promise<TaskStatusResponse> {
    const raw = await api.post<unknown>('/api/v1/processing_tasks', payload);
    return unwrap<TaskStatusResponse>(raw);
  },

  async status(taskId: string, since = 0): Promise<TaskFrame> {
    const raw = await api.get<unknown>(`/api/v1/processing_tasks/${taskId}/status`, {
      query: { since, include_reasoning: false },
    });
    return unwrap<TaskFrame>(raw);
  },

  async retrySlow(taskId: string): Promise<TaskStatusResponse> {
    const raw = await api.post<unknown>(`/api/v1/processing_tasks/${taskId}/retry/slow`);
    return unwrap<TaskStatusResponse>(raw);
  },

  streamPath(taskId: string): string {
    return `/api/v1/processing_tasks/${taskId}/stream`;
  },
};
